import { useGetInternalWidgets, updateWidgetPropertyByPath, useAppDispatch } from '@libs/store';
import { IUpdateWidgetPropertyByPath, TCommonData, TWidget } from '@libs/types';
import { calculateFunctions, getFunctionsObject } from '@libs/utils';
import { useEffect } from 'react';

export const useFunction = (widget: TWidget<TCommonData>) => {
    const dispatch = useAppDispatch();
    const { internalIds, functionObjects } = getFunctionsObject(widget.functions);

    const mutableInternalIdWidgets = useGetInternalWidgets(internalIds);

    useEffect(() => {
        if (internalIds.size > 0) {
            const updateWidgetPropertyByPathUtils = (payload: IUpdateWidgetPropertyByPath) => {
                dispatch(updateWidgetPropertyByPath(payload));
            };
            calculateFunctions(widget, functionObjects, mutableInternalIdWidgets, updateWidgetPropertyByPathUtils);
        }
    }, [dispatch, functionObjects, internalIds, mutableInternalIdWidgets, widget]);
};
